<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
        label-width="120px" :rules="rules" size="mini">
        <!-- <el-divider content-position="left">试卷信息</el-divider> -->
        <el-row>
          <el-col :span="16">
            <el-form-item label="试卷名称" prop="name">
              <el-input v-model="formParameter.name" autocomplete="off"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支持移动端" prop="isMobile">
              <el-checkbox v-model="formParameter.isMobile" @change="reset"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- 选择科目 -->
          <el-col :span="8">
            <el-form-item label="科 目" prop="kid">
              <el-input placeholder="请选择科目" disabled v-model="sbname">
                <template slot="append">
                  <el-button type="primary" @click="selectSub()">{{ sbname ? '重新选择' : '选择' }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总分" prop="score">
              <el-input v-model="formParameter.score" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="及格分数" prop="passScore">
              <el-input v-model="formParameter.passScore" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="类型" prop="type">
              <select-option-dictionary disabled v-model="formParameter.type" :clearable="false" dkey="exp-type">
              </select-option-dictionary>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="考试时间(分钟)" prop="duration">
              <el-input v-model="formParameter.duration" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="status">
              <select-option-dictionary v-model="formParameter.status" :clearable="false" dkey="y-n-status">
              </select-option-dictionary>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="mark">
              <el-input type="textarea" v-model="formParameter.mark" autocomplete="off"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- -------------------------------- -->
        <template>
          <el-divider content-position="left">选择题型分布</el-divider>
          <el-row>
            <el-col :span="17">
              <el-row style="margin-bottom:10px">
                <el-col :span="16" style="text-align: center;">
                  <p v-show="sum != 100" style="color:red;font-size:12px;padding-left: 40px;">为统计分析标准化,必须按满分100分配置试卷。
                  </p>
                </el-col>
              </el-row>

              <el-row v-for="(v, idx) in labelTxts" :key="v"
                v-show="idx == 0 || idx == 1 || idx == 2 || idx == 4 || idx == 6">
                <el-col :span="24">
                  <el-form-item :label="v" :inline="true">
                    <el-col :span="5">
                      <el-input v-model="inputT[idx]" :disabled="qudingBut[idx].but"> </el-input>
                    </el-col>
                    <el-col :span="3" style="text-align:center"> 道，每道 </el-col>
                    <el-col :span="4">
                      <el-input v-model="oneChoice[idx]" :disabled="qudingBut[idx].but"></el-input>
                    </el-col>
                    <el-col :span="3" style="text-align:center"> 分，共 </el-col>
                    <el-col :span="4">
                      <el-input v-model="inputS[idx]" :disabled="true"></el-input>
                    </el-col>
                    <el-col :span="2" style="padding-left: 5px;">分。</el-col>
                    <el-col :span="2" v-if="inputT[idx] > 0 && inputS[idx] > 0">
                      <el-button type="success" size="mini" @click="edutT(idx + 1)"
                        v-if="qudingBut[idx].but == true">配置题目</el-button>
                      <el-button type="danger" size="mini" @click="edutT(idx + 1)" v-else>配置题目 </el-button>
                    </el-col>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-col>
          </el-row>

          <!-- ----------------配置题目----------------- -->
          <el-drawer title="配置题目" :visible.sync="drawer" :append-to-body="true" :before-close="handleClose"
            custom-class="demo-drawer" size="80%" :wrapperClosable="false" :close-on-press-escape="false">
            <div class="demo-drawer__content">
              <el-row>
                <el-col :span="24">
                  <el-card shadow="never">
                    <el-form ref="form" :model="searchParams" label-width="80px">
                      <el-row>
                        <el-col :span="4">
                          <div class="cenIn">
                            <span v-if="typeId == 1">
                              <span>单选题：</span>
                            </span>
                            <span v-if="typeId == 2">
                              <span>多选题：</span>
                            </span>
                            <span v-if="typeId == 3">
                              <span>判断题：</span>
                            </span>
                            <span v-if="typeId == 5">
                              <span>简答题：</span>
                            </span>
                            <span v-if="typeId == 7">
                              <span>编程题：</span>
                            </span>
                            <span> {{ inputT[typeId - 1] }} </span>
                            <b> / </b>
                            <span> {{ multipleSelection.length }} </span>
                            <span> 共{{ inputS[typeId - 1] }}分 </span>
                          </div>
                        </el-col>
                        <el-col :span="4" style="margin-top: 5px;">
                          <el-button type="success" size="mini" @click="innerVisibleBut">
                            科目
                          </el-button><span style="font-size: 11px;">{{ sbname2 }}</span>
                        </el-col>
                        
                        <div class="search-btn">
                          <el-button type="primary" icon="el-icon-search" @click="list" style="margin-left:20px">搜索
                          </el-button>
                          <el-button @click="clearSearchVal">清空</el-button>
                        </div>
                      </el-row>
                    </el-form>
                  </el-card>
                </el-col>
              </el-row>
              <div class="dataTable autoFlex" v-if="listData">
                <el-table class="table" :data="listData.records" stripe border v-loading="listLoading" :row-key="rowKey"
                  ref="multipleTable" @selection-change="handleSelectionChange">
                  <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
                  <el-table-column prop="name" label="试题名称" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="sbname" width="220px" label="科目"></el-table-column>
                  <el-table-column prop="type" width="110px" label="试题类型">
                    <template slot-scope="scope">
                      <!-- 试题 1-单选题、2多选题、3-判断题、4-填空题、5-、简答题、6-论述题、7-分析题 -->
                      <p v-if="scope.row.type == 1">单选题</p>
                      <p v-if="scope.row.type == 2">多选题</p>
                      <p v-if="scope.row.type == 3">判断题</p>
                      <p v-if="scope.row.type == 5">简答题</p>
                      <p v-if="scope.row.type == 7">编程题</p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="level" width="55px" label="星级">
                  </el-table-column>
                  <el-table-column prop="easy" width="55px" label="难度">
                  </el-table-column>

                  <el-table-column prop="exposeTimes" width="90px" label="出题次数">
                    <template slot-scope="scope">
                      <p>{{ scope.row.rightTimes }} / {{ scope.row.exposeTimes }}</p>
                    </template>
                  </el-table-column>


                  <el-table-column prop="reference" width="110px" label="来源"></el-table-column>
                </el-table>
                <div class="pageBar" v-if="this.parameter.type == 5">
                  <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
                    :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
                    :page-sizes="this.$constant.page.pageSizes"></el-pagination>
                </div>
              </div>
              <div class="demo-drawer__footer">
                <el-button type="primary" @click="confirmE()">确认</el-button>
                <!-- <el-button @click="cancelForm">取 消</el-button> -->
              </div>
            </div>
          </el-drawer>
        </template>


      </el-form>

      <!-- 选择科目 -->
      <el-dialog title="试卷绑定科目" :visible.sync="dialogVisible" width="60%" :append-to-body="true">
        <tree class="filter-tree" ref="permissionTree" check-strictly :items="permissionList" :data="permissionList"
          :defaultParent="0" @nodeClick="treeClick" :expand-on-click-node="true"> </tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="comfirmSub">选定科目</el-button>
        </span>
      </el-dialog>

      <!-- 选择科目 -->
      <el-dialog title="选择科目下的题" :visible.sync="innerVisible" width="60%" :append-to-body="true">
        <tree class="filter-tree" ref="permissionTree" check-strictly :items="permissionList" :data="permissionList"
          :defaultParent="0" @nodeClick="treeClick4Que" :expand-on-click-node="true"> </tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="comfirmSub4Que">选定科目</el-button>
        </span>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled && sum == 100" type="primary" :loading="confirmLoading" @click="confirm()">确 定
      </el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue'
import api from '@/api/exams/exampaper/exampaper.js'
import subApi from '@/api/edu/subject/subject.js'
import tree from '@/components/tree/tree.vue'
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue'

import apiQ from "@/api/exams/question/question.js";

export default {
  name: 'edit',
  components: {
    popup,
    selectOptionDictionary,
    tree
  },data() {
    return {
      //课程-模块-科目信息 全部数据
      permissionList: false,
      sbname: '', //科目名称
      dialogVisible: false, //科目弹框开关
      subData: {},//选中的科目信息
      // 树 的最后一个的id集
      subId: "",

      //---树--选择题型 模态框弹出为false
      innerVisible: false,
      sbname2: '', //科目名称
      subData2: {}, //选中的科目信息


      labelTxts: ['单选题', '多选题', '判断题', '填空题x', '简答题', '论述题x', '编程题'],

      searchParams: {},
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      page: new this.$constant.pageObj(),

      rules: {
        //试卷名称
        name: [{ required: true, message: '请输入试卷名称', trigger: 'blur' }],
        kid: [{ required: true, trigger: 'blur' }],
      },

      listLoading: false,
      qudingBut: [{ but: false }, { but: false }, { but: false }, { but: false }, { but: false }, { but: false }, { but: false }],

      sum: 0,         //总分
      inputT: [],    //分类题型的数量
      inputS: [],    //分类题型的总分值
      oneChoice: [], //分类题型的 单题分值

      //---树--选择题型 模态框弹出为false
      innerVisible: false,


      //---抽屉--抽屉弹出
      drawer: false,
      typeId: undefined,
      listData: [],
      //题目复选款
      multipleSelection: [],

      content: {},
      con: [],   //配置好的分类-考题

      expIds: false
    }
  },

  watch: {
    //监听选择题型时的类型
    inputT: {
      handler: function (val, oldval) {

        if (this.inputT.length > 0) {
          this.sum = 0
          let types = []
          let qnums = []
          for (let i = 0; i < this.inputT.length; i++) {
            let element = this.inputT[i]
            if (element == '' || element == null || element == undefined) {
              element = 0
            }
            if (!isNaN(element)) {
              if (element > 0) {
                types.push(parseInt(i + 1))
                qnums.push(this.inputT[i])

                if (this.oneChoice[i] > 0) {
                  let c = this.inputT[i] * 1 * this.oneChoice[i]
                  this.inputS[i] = c
                } else {
                  this.inputS[i] = 0
                }
              } else {
                this.inputS[i] = 0
              }
            } else {
              element = 0
              this.$utils.msg.warning('请输入数字。', 2000)
              this.inputT[i] = undefined
            }
            this.sum += parseInt(this.inputS[i])
          }
          this.content.types = types
          this.content.qnums = qnums

        } else {
          this.inputS = []
        }
      },
      deep: true
    },
    //监听题型的每道题分数
    oneChoice: {
      handler: function (val, oldval) {
        if (this.oneChoice.length > 0) {
          this.sum = 0
          let oneC = [] //每道单选框分数
          let scores = [] //每种题总分
          for (let i = 0; i < this.oneChoice.length; i++) {
            let element = this.oneChoice[i]
            if (element == '' || element == null || element == undefined) {
              element = 0
            }
            if (!isNaN(element)) {
              //判断如果有分数就把该索引+1加入数组中 scores
              if (element > 0) {
                oneC.push(element)
                if (this.inputT[i] > 0) {
                  let c = this.inputT[i] * 1 * this.oneChoice[i]
                  scores.push(c)
                  this.inputS[i] = c
                } else {
                  this.inputS[i] = 0
                }
              } else {
                this.inputS[i] = 0
              }
            } else {
              element = 0
              this.$utils.msg.warning('请输入数字。', 2000)
              this.oneChoice[i] = undefined
            }
            this.sum += parseInt(this.inputS[i])

          }
          this.content.scores = scores

        } else {
          this.inputS = []
        }
      },
      deep: true
    },

    //题目数量选择监听
    multipleSelection: {
      handler(val, olVal) {
        if (this.multipleSelection.length > this.inputT[this.typeId - 1]) {
          this.$refs.multipleTable.toggleRowSelection(this.multipleSelection[this.multipleSelection.length - 1])
          // console.log("this.multipleSelection",this.multipleSelection);
          this.$utils.msg.warning('选择已超过上限。')
        }
      },
      deep: true
    }
  },

  methods: {
    reset() {
      //
      this.qudingBut = [{ but: false }, { but: false }, { but: false }, { but: false }, { but: false }, { but: false }, { but: false }],
        this.sum = 0         //总分
      this.inputT = []    //分类题型的数量
      this.inputS = []    //分类题型的总分值
      this.oneChoice = [] //分类题型的 单题分值
      this.multipleSelection = []
      this.content = {}
      this.con = []

      this.formParameter.score = 100
    },

    // 选择科目
    selectSub() {
      this.dialogVisible = true
      //强制刷新
      setTimeout(() => {
        this.permissionList = JSON.parse(JSON.stringify(this.permissionList))
      }, 100)
    }, treeClick(data) {
      this.subData = data
    }, comfirmSub() {
      this.sbname = this.subData.name
      this.formParameter.kid = this.subData.id
      this.searchParams.subId = this.formParameter.kid
      this.sbname2 = this.subData.name
      this.dialogVisible = false
    },
    selectSub4Que() {
      this.innerVisible = true
      setTimeout(() => {
        //强制刷新
        this.permissionList = JSON.parse(JSON.stringify(this.permissionList))
      }, 100)
      this.searchParams.subId = this.formParameter.kid

    }, treeClick4Que(data) {
      this.subData2 = data
    }, comfirmSub4Que() {
      this.sbname2 = this.subData2.name
      this.searchParams.subId = this.subData2.id
      this.page.current = 1
      this.list()
      this.innerVisible = false
    },


    //打开弹框
    open(parameter, examIds, title, disabled, size) {
      this.paperName =undefined
      this.parameter = parameter
     // console.log("this.parameter ", this.parameter)
      this.expIds = examIds
      if("添加覆盖试卷"==title){
        this.paperName = "覆盖卷"+new Date().format("yyMMddHHmm")
      }

      this.disabled = disabled
      this.$refs.popup.open(title, size)
      this.$nextTick(() => {
        this.init()
      })
    },
    //关闭弹框
    close() {
      this.disabled = false
      this.$refs.popup.close()
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {


        //单选题 分数 逻辑判断
        if (this.inputT[0] || this.inputT[1] || this.inputT[2] || this.inputT[4] || this.inputT[6]) {

          //各种题型 分数 逻辑判断
          this.labelTxts.forEach((v, i) => {

            if (this.inputT[i]) {
              if (!this.oneChoice[i]) {
                this.$utils.msg.warning('请' + v + '填写有误。', 2000)
                return
              }
            } else if (this.oneChoice[i]) {
              if (!this.inputT[i]) {
                this.$utils.msg.warning(v + '填写有误。', 2000)
                return
              }
            }

          })
        } else {
          this.$utils.msg.warning('请选择至少一种题。')
          return
        }

        //排序
        this.con.sort((a, b) => {
          //console.log(a, b)
          return a.typeId - b.typeId
        })

        //配置题目按钮完成变颜色 判断有没有全部配置好
        for (let i = 0; i < this.inputT.length; i++) {
          if (this.inputT[i] > 0) {
            for (let j = 0; j < this.qudingBut.length; j++) {
              const e = this.qudingBut[i]
              if (e.but == false) {
                this.$utils.msg.warning('请把配置题目选择完整，完成将变成绿色。')
                return
              }
            }
          }
        }

        this.confirmLoading = true

        let contents = []
        for (let i = 0; i < this.con.length; i++) {
          const element = this.con[i]
          if (element && element.pid) {
            contents.push({ qid: element.pid, qscore: element.qscore })
          }
        }

        this.content.contents = contents

        if (this.parameter.type * 1 == 1) {
          this.formParameter.type = this.parameter.type
        } else {
           //覆盖考试 对应 试卷为 -1：覆盖试卷
          this.formParameter.type = -1
        }

        if (!this.parameter.id) {

          this.formParameter.content = JSON.stringify(this.content)
          let exampaper = this.$utils.merger(this.formParameter)
          let exams = this.parameter;

          if (this.parameter.type * 1 == 1) {
            exampaper.cid = this.parameter.cid.id;
          } else {
            exampaper.cid = this.parameter.cid;
          }
          exams.cid = exampaper.cid
          exams.sid = exams.sid[0]

          //            试卷        考试
          let exall = { exampaper, exams };

          let parameter = this.$utils.merger(exall);

          api.saveExamsandPaper(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );


        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter)
          api.update(
            parameter,
            response => {
              this.$utils.msg.success(response.msg)
              this.confirmLoading = false
              this.close()
              this.$parent.list()
            },
            response => {
              this.$utils.msg.warning(response.msg)
              this.confirmLoading = false
            }
          )
        }
      })
    },
    init() {
      this.popupLoading = true
      //清除等待
      this.confirmLoading = false
      //清空内容{ type: 1, status: 1,duration:60, passScore:60},

      this.formParameter = { type: this.parameter.type == 1 ? 1 : -1, status: 1, score: 100, duration: 60, passScore: 60 }

      if( this.paperName){
        this.formParameter.name = this.paperName
      }

      this.sbname = '';

      this.qudingBut = [{ but: false }, { but: false }, { but: false }, { but: false }, { but: false }, { but: false }, { but: false }]

      this.inputS = []
      this.inputT = []
      this.questionCart = []

      this.oneChoice = []
      this.con = []
      //清楚校验
      this.$refs.form.clearValidate()

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id
        }
        api.toUpdate(parameter, response => {
          this.formParameter = response.data
          this.popupLoading = false
        })
      } else {
        //添加
        this.popupLoading = false
      }
      //加载全部科目
      if (!this.permissionList) {
        subApi.list({}, response => {
          this.permissionList = response.data
        })
      }

    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val
      this.list()
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val
      this.list()
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {}
      this.sbname2 = ''
      this.subId = ''
      this.list()
    },
    // ---------------选择题型按钮部分-------
    //为题目选择课程-模块-科目信息
    innerVisibleBut() {
      this.innerVisible = true
      this.listLoading = true
      subApi.list({}, response => {
        this.permissionList = response.data
        this.listLoading = false
      })
    },
    handleCloseTree(done) {
      this.$confirm('确定关闭吗？')
        .then(_ => {
          done()
        })
        .catch(_ => { })
    },

    //配置题目里的确认按钮
    confirmT() {
      this.innerVisible = false
      this.listLoading = false
      this.subId = ''

      this.list(this.typeId)
    },
    // ------------------配置题目按钮部分-------
    // 配置题目按钮-打开抽屉
    edutT(type) {

      this.listData = [];
      this.typeId = type;
      this.listLoading = true;


      if (this.parameter.type * 1 == 1) {
        //线下考试

        //加载题目
        apiQ.listByType({ type: this.typeId, ids: this.expIds }, (res) => {
          this.listLoading = false;
          if (res.data) {
            if (this.inputT[type - 1] * 1 > res.data.length) {
              this.$utils.confirm.warning(
                "警告：",
                "您选的试卷中该类题型数量不够：" +
                this.inputT[type - 1] +
                "道！"
              );
            } else {
              this.drawer = true;

              this.multipleSelection = [];

              // 线下考试无分页，覆盖考试有分页  listData.records
              this.page.size = res.data.total
              // 线下考试
              this.listData.records = res.data;
              //全部放在一页
              this.listData.total = this.listData.records.length
              // this.page.size = this.listData.total 
              this.page.current = 1

              if (this.con.length > 0) {
                for (let i = 0; i < this.con.length; i++) {
                  const element = this.con[i];

                  if (id == element.typeId) {
                    element.mul.forEach((row) => {
                      this.$refs.multipleTable.toggleRowSelection(row, true);
                    });
                  }
                }
              }
            }
          } else {
            this.$utils.msg.warning("您选的试卷中没有该类题型!");
            this.oneChoice[type - 1] = "";
            this.inputS[type - 1] = "";
          }
        });

      } else {
        // console.log("this.kid ==============>>>>>>>>>>>>>>>>",this.formParameter.kid )
        //listWithOutDoneByClazzStus 覆盖考试             listByWithOutDoneClazzStus(page,type,cid, snms)
        apiQ.listWithOutDoneByClazzStus({ type: this.typeId,subId:this.formParameter.kid , cid: this.parameter.cid, snms: this.parameter.sid }, (res) => {
          this.listLoading = false;
          if (res.data) {
            if (this.inputT[type - 1] * 1 > res.data.length) {
              this.$utils.confirm.warning(
                "警告：",
                "您选的试卷中该类题型数量不够：" +
                this.inputT[type - 1] +
                "道！"
              );
            } else {
              this.drawer = true;

              this.multipleSelection = [];

              //覆盖考试
              this.listData = res.data;

              if (this.con.length > 0) {
                for (let i = 0; i < this.con.length; i++) {
                  const element = this.con[i];

                  if (id == element.typeId) {
                    element.mul.forEach((row) => {
                      this.$refs.multipleTable.toggleRowSelection(row, true);
                    });
                  }
                }
              }
            }
          } else {
            this.$utils.msg.warning("您选的试卷中没有该类题型!");
            this.oneChoice[type - 1] = "";
            this.inputS[type - 1] = "";
          }
        });

      }


    },
    list() {

      if (this.parameter.type * 1 == 1) {

        this.searchParams.typeId = this.typeId
        let params = this.$utils.merger(this.searchParams, this.page)
        api.listQuesExamp(params, response => {
          this.listData = response.data
          this.listLoading = false
        })

      } else {

        let params = this.$utils.merger({ type: this.typeId, cid: this.parameter.cid, snms: this.parameter.sid }, this.page)
        params = this.$utils.merger(this.searchParams, params)

        apiQ.listWithOutDoneByClazzStus(params, (res) => {
          this.listLoading = false;
          if (res.data) {
            this.listData = res.data;
          }
        })
      }

    },
    //配置题目弹出抽屉关闭回调
    handleClose(done) {
      this.$refs.multipleTable.clearSelection()
      done()
    },
    //配置某类型的考题
    confirmE() {
      if (this.inputT[this.typeId - 1] != this.multipleSelection.length) {
        this.$utils.msg.warning('还缺少题目，请选择。')
        return
      }

      let qscore = []
      let qsc = Math.floor(parseInt(this.inputS[this.typeId - 1]) / parseInt(this.inputT[this.typeId - 1]))
      for (let i = 0; i < parseInt(this.inputT[this.typeId - 1]); i++) {
        qscore.push(qsc)
      }
      if (this.multipleSelection.length > 0) {
        let pid = []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          const element = this.multipleSelection[i]
          pid.push(element.id)
        }
        if (this.con.length > 0) {
          for (let i = 0; i < this.con.length; i++) {
            const element = this.con[i]
            if (this.typeId == element.typeId) {
              this.con[i] = this.con.push({ typeId: this.typeId, pid: pid, mul: this.multipleSelection, qscore: qscore })
              this.drawer = false
              this.$refs.multipleTable.clearSelection()
              return
            }
          }
        }

        this.con.push({ typeId: this.typeId, pid: pid, mul: this.multipleSelection, qscore: qscore })
        this.qudingBut[this.typeId - 1] = { but: true }
      }


      this.drawer = false
      this.$refs.multipleTable.clearSelection()
    },
    rowKey(row) {
      return row.id
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';

/deep/.el-card__body {
  padding: 5px;
}

/deep/.boxTextItem {
  height: 270px;
  overflow: auto;
}

/* // -------------选择题型--------------- */
.contTree {
  height: calc(100vh - 260px);
  overflow: auto;
}

/* // --------------配置题目抽屉------- */

.demo-drawer__content {
  padding: 0 20px;
}

.demo-drawer__footer {
  position: fixed;
  bottom: 20px;
}

/* // 题目选择表格高度 */
.table {
  height: calc(100vh - 250px);
  overflow: auto;
}

.cenIn {
  margin: 10px;
}
</style>
